export enum LabourForecastPermissions {
  GET_LABOUR_FORECAST = 'labourForecast.getLabourForecast',
  CREATE_LABOUR_FORECAST = 'labourForecast.createLabourForecast',
  UPDATE_LABOUR_FORECAST = 'labourForecast.updateLabourForecast',
  DELETE_LABOUR_FORECAST = 'labourForecast.deleteLabourForecast',
}
